import { Component, AfterViewInit, OnInit, OnDestroy, OnChanges, SimpleChanges, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from '../../shared/constants/constants';
import { BaseService } from '../../shared/services/base.service';
import { RequestAppointmentService } from '../../pages/request-appointment/request-appointment.service';
import { ViewUploadedDocumentsService } from '../../pages/view-uploaded-documents/view-uploaded-documents.service';
import { UserUrl } from '../../shared/urls/user.url';

@Component({
    selector: 'app-header',
    templateUrl: 'header.component.html',
    providers: [RequestAppointmentService, ViewUploadedDocumentsService]
})

export class HeaderComponent implements AfterViewInit, OnInit, OnDestroy, OnChanges {
    @Output() menuToggle = new EventEmitter<boolean>();
    public userName: string;
    public userAccount:string;
    public tmbLogo = '/assets/images/logo.png';
    public nomadLogo = '/assets/images/nomad_logo.png';
    constructor(
        private router: Router,
        private baseService: BaseService,
        private requestAppointmentService: RequestAppointmentService,
        private viewUploadedDocumentsService: ViewUploadedDocumentsService
    ) { }
    ngAfterViewInit() {
    }

    ngOnInit() {
      this.userName = localStorage.getItem(AppConstants.localStorage.userName);
      this.userAccount = localStorage.getItem(AppConstants.localStorage.userAccount);
    }

    ngOnChanges(e: SimpleChanges) {
    }

    ngOnDestroy() {
    }

    onChangePassword() {
        //navigate to change password page
        this.router.navigate(["/change-password"]);
    }

    toggleMenu() {
        this.menuToggle.emit(true);
    }

    onLogout() {
      this.baseService.getData(UserUrl.CHECK_TMB_USER).subscribe(
        result => {
          const data = result.json();
          if (data.status) {
            this.baseService.logout();
          }
        }
      );

      var model = {
          //userId : localStorage.getItem(this.appConstants.activeLink.userId),
          consultationId: null,
          message: ` logout`
        };
        this.viewUploadedDocumentsService.addAuditTrail(model).subscribe(res => {
      });
      // delete booking cache (SD10001680-604)
      this.requestAppointmentService.deleteBookingCache().subscribe(
          (result) => {
              this.baseService.logout();
          }
      );
    }

    /**
 * function to update user name when user info is changed
 * @param data
 */
    updateUserInfo(data) {
        if (data && data.hasOwnProperty('firstName') && data.hasOwnProperty('lastName')) {
            this.userName = data['firstName'] + ' ' + data['lastName'];
            // set user name to localstorage
            localStorage.setItem(AppConstants.localStorage.userName, data['firstName'] + ' ' + data['lastName']);
        }
    }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/components/header/header.component.ts